<ion-card>
  <ion-card-header>
    <ion-toolbar>
      <!-- header icon -->
      <ion-icon slot="start" size="large" [src]="icon || 'help' | getIcon"></ion-icon>

      <!-- title -->
      <ion-title>{{ title }}</ion-title>
    </ion-toolbar>
  </ion-card-header>

  <ion-card-content>
    <!-- description -->
    <ng-content select="[config-description]"></ng-content>

    <div class="app-margin-divider"></div>

    <!-- content -->
    <ng-content select="[c3ConfigForm]"></ng-content>

    <ng-container *ngIf="!hideSaveBtn">
      <div class="app-margin-divider"></div>

      <ion-toolbar>
        <app-form-valid-tick
          slot="start"
          [formValid]="valid$ | async"
          [formTouched]="touched$ | async"
        >
        </app-form-valid-tick>

        <ion-buttons slot="end">
          <ion-spinner color="secondary" *ngIf="loading$ | async"></ion-spinner>

          <ion-button
            color="secondary"
            fill="solid"
            (click)="onSave()"
            *ngIf="!(loading$ | async)"
            [disabled]="(loading$ | async) || !(touched$ | async) || !(valid$ | async)"
          >
            <span>Salva</span>
            <ion-icon slot="end" [src]="'content-save' | getIcon"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ng-container>
  </ion-card-content>
</ion-card>
